import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  DashBoard: {
    menuList: ["사업장 대시보드", "회사 대시보드", "그룹사 대시보드"],
  },
  EnergyNote: {
    menuList: [
      "사용현황",
      "설비별 사용전력",
      "월별 사용 요금",
      "전기요금분석",
      "에너지 원단위",
      "전력품질 현황",
      "사용량상관분석",
      "소비량예측",
      "에너지진단",
      "사용량입력",
    ],
  },
  FacilityNote: {
    menuList: [
      "설비 현황",
      "Digital Twin",
      "효율화M&V",
      "통계/조회",
      "유지관리",
      "운영보고서",
      "설비정보관리",
    ],
  },
  CarbonNote: {
    menuList: [
      "탄소발자국",
      "탄소발생 조회",
      "RE100 이행 전략",
      "RE100 이행 현황",
      "RE100 이행 보고",
      "RE100 인증관리",
      "재생에너지조달",
    ],
  },
  EnviNote: {
    menuList: ["기획 미정"],
  },
  Motorman: {
    menuList: ["모터현황", "정비히스토리", "보고서"],
  },
  DRman: {
    menuList: ["기획 미정"],
  },
  ESSman: {
    ESSman: ["수익 현황", "운영 평가", "운영 제안", "수익 관리"],
  },
  PVman: {
    menuList: ["지붕태양광", "태양광 발전량", "수익금", "O&M이력"],
  },
  subMenuCheckedNumber: 1,
};

export const cemsSlice = createSlice({
  name: "cems",
  initialState,
  reducers: {
    changeSubMenuCheckedNumber: (state, action) => {
      state.subMenuCheckedNumber = action.payload;
    },
    plusSubMenuCheckedNumber: (state) => {
      state.subMenuCheckedNumber = state.subMenuCheckedNumber + 1;
    },
    minusSubMenuCheckedNumber: (state) => {
      state.subMenuCheckedNumber = state.subMenuCheckedNumber - 1;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  changeSubMenuCheckedNumber,
  plusSubMenuCheckedNumber,
  minusSubMenuCheckedNumber,
} = cemsSlice.actions;

export default cemsSlice.reducer;
